import { useContext } from 'react';
import {
  Context,
  RoutePropsContext,
} from '@prodelio/context/route-props-provider/RouteProps.provider';

export const useRouteProps = () => {
  return useContext<Context>(RoutePropsContext);
};
